import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-attribute"
export default class extends Controller {
	static targets = ["inputRemove"]

	connect() {}

	remove() {
		this.inputRemoveTarget.value = true
		this.element.classList.add("hidden")
	}
}
